class UserService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    /***
     * Get details about a specific user.
     *
     * @param userId        the ID of the user being fetched.
     */
    getUser(userId) {
        return this.$http.get(`${this.appConfig.apiUrl}/users/${userId}/`)
            .then((successResponse) => successResponse.data)
    }


    /***
     * Update the given user.
     *
     * @param userId        the ID of the user being updated.
     * @param data          a dictionary of values to be updated. Potential keys include: client,
     *                      is_survey_admin, is_client_admin
     *
     * @returns {Promise}
     */
    updateUser(userId, data) {
        return this.$http.patch(`${this.appConfig.apiUrl}/users/${userId}/`, data);
    }

}

export default UserService;


// WEBPACK FOOTER //
// ./app/components/user-admin/user/user-service.js